// Header theme toggle, exactly as the mockup's {{themeIcon}} {{themeLabel}}:
// in dark it offers "☀ LIGHT", in light it offers "☾ DARK".
import { useTheme } from './useTheme';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label="Toggle light / dark theme"
    >
      <span aria-hidden="true">{theme === 'dark' ? '☀' : '☾'}</span>
      <span className="theme-toggle-label">{theme === 'dark' ? 'LIGHT' : 'DARK'}</span>
    </button>
  );
}
